import { Decimal } from 'decimal.js'

import { CalculadoraDePercentual } from '@/utils/calculadora-de-percentual'
import { ProcessadorValoresDecimal, type IProcessadorValoresDecimal } from '@/utils/calculadora-valores-totais'
import type { TGrupoParcelasValoresTotais } from '@/utils/calculadora-valores-totais/calculadora-valores-totais'
import { formatToBRL } from '@/utils/currency.utils'

export class CalculadoraDeValoresTotaisSacocVParcelado {
  constructor(
    private readonly grupos: TGrupoParcelasValoresTotais,
    private readonly valorTabela = 0,
    private readonly processador: IProcessadorValoresDecimal = new ProcessadorValoresDecimal(),
  ) {}

  get calcularPercentual() {
    return new CalculadoraDePercentual([this.valorPoupanca, this.valorPosConclusao])
  }

  get totalDeEntradas() {
    return this.processador.calcularTotalEntradas(this.grupos?.entradas)
  }

  get totalDeMensais() {
    return this.processador.calcularTotalMensais(this.grupos?.mensais)
  }

  get totalDeIntermediarias() {
    return this.processador.calcularTotalIntermediarias(this.grupos?.intermediarias)
  }

  get valorPoupanca() {
    return new Decimal(this.totalDeEntradas).plus(this.totalDeMensais).plus(this.totalDeIntermediarias).toNumber()
  }

  get valorPosConclusao() {
    return new Decimal(this.processador.calcularValorPosConclusao(this.grupos?.posConclusao))
      .plus(this.processador.calcularTotalIntermediarias(this.grupos?.intermediariasPosConclusao))
      .toNumber()
  }

  get valorBeneficio() {
    return new Decimal(this.valorTabela).minus(this.valorTotalSimulacao).toNumber()
  }

  get valoresChart() {
    return [
      {
        tipo: 'poupanca' as const,
        percentual: this.calcularPercentual.calcularPercentual(this.valorPoupanca),
        valor: formatToBRL(this.valorPoupanca),
      },
      {
        tipo: 'posConclusao' as const,
        percentual: this.calcularPercentual.calcularPercentual(this.valorPosConclusao),
        valor: formatToBRL(this.valorPosConclusao),
      },
    ]
  }

  get valoresLegendaGrafico() {
    return [
      {
        tipo: 'poupanca' as const,
        value: this.valorPoupanca,
        percentual: this.calcularPercentual.calcularPercentualFormatado(this.valorPoupanca),
      },
      {
        tipo: 'posConclusao' as const,
        value: this.valorPosConclusao,
        percentual: this.calcularPercentual.calcularPercentualFormatado(this.valorPosConclusao),
      },
      {
        tipo: 'beneficio' as const,
        value: this.valorBeneficio,
        percentual: null,
      },
    ]
  }

  get valorTotalSimulacao() {
    return new Decimal(this.valorPoupanca).plus(this.valorPosConclusao).toNumber()
  }

  get isPagamentoAVista() {
    return this.totalDeEntradas === this.valorTotalSimulacao
  }
}
